import { useEffect, useState } from "react";
import "./assets/css/style.css";
import player from "./assets/img/player.svg";
import * as Sentry from "@sentry/react";
import Swal from "sweetalert2";
import { sendRewardEvent, fetchAdTag } from "./api";

function App() {
  const [adID] = useState("");
  const urlParams = new URLSearchParams(window.location.search);
  const token = decodeURIComponent(urlParams.get("t") || urlParams.get("T") || "");

  useEffect(() => {
    Sentry.init({
      dsn: "https://6c3cc0e0d50f97d56fa4dbac5a2ee239@sentry.jssec.wtf/15",
      integrations: [Sentry.browserTracingIntegration(), Sentry.browserProfilingIntegration()],
      tracesSampleRate: 1.0,
      tracePropagationTargets: ["localhost", /^https:\/\/api\.misfitsminecraft\.gg/],
      replaysSessionSampleRate: 0.1,
      replaysOnErrorSampleRate: 1.0,
      profilesSampleRate: 1.0
    });

    const scrippsVideoPlayerEvents = {
      AD_LOADED: async (d) => {
        sendRewardEvent(token, adID, "ad_loaded", d.data.message);
      },
      AD_START: () => sendRewardEvent(token, adID, "ad_start"),
      AD_ERROR: (d) => {
        console.log(d)
        document.getElementById("scrippsvideoplayer").innerHTML = "";

        var data = JSON.parse(d.data);
        switch (data.type) {
          case 'adLoadError':
              Swal.fire({
                icon: 'warning',
                title: 'Sorry!',
                text: 'No ads are available at this time.'
              })
              sendRewardEvent(token, adID, "no_ad", data.message);
              break;
          default:
            Swal.fire({
              icon: 'warning',
              title: 'Uh oh!',
              text: 'An error has occurred.'
            })
            sendRewardEvent(token, adID, "ad_error", data.message);
            break;
      }
      },
      AD_END: () => {
        Swal.fire({ icon: "success", title: "Thank You!", text: "Please close this window to return to the game." });
        document.getElementById("scrippsvideoplayer").innerHTML = "";
        sendRewardEvent(token, adID, "ad_complete");
      },
      IMA_NOT_LOADED: () => {
        document.getElementById("scrippsvideoplayer").innerHTML = "";
        Swal.fire({ icon: "warning", title: "Ad Blocker Detected", text: "Please disable your ad blocker and try again." });
        sendRewardEvent(token, adID, "ad_blocker");
      },
    };

    async function initScrippsVideoPlayer() {
      const playerContainer = document.querySelector(".scrippsvideoplayer");
      if (!playerContainer) return;

      // Fetch ad tag from backend
      var adTag = await fetchAdTag(token);
      if (!adTag) {
        adTag = "/6088/misfitsgaming/minecraft_test"
      }

      // Construct video player URL with the retrieved ad tag
      const videoSrc = `https://imm.ewscloud.com/video/minecraft/player.html?video=blank.mp4&ads.bidders=none&ads.proxy=1&ads.iu=${adTag}&ads.tfcd=1&ads.url=${encodeURIComponent("https://www.newsy.com/")}&ads.description_url=${encodeURIComponent("https://www.newsy.com/")}&ads.disableClickthrough=true`;

      playerContainer.innerHTML = `
        <div class="scripps_iframe_embed" style="position:relative;">
          <div style="display:block;width:100%;height:auto;padding-bottom:56.25%;"></div>
          <iframe style="position:absolute;top:0;left:0;width:100%; height:100%;" frameborder="0" allowfullscreen src="${videoSrc}"></iframe>
        </div>`;

      window.addEventListener("message", (event) => {
        try {
          console.log(`event = ${event}`)
          const eventData = JSON.parse(event.data);
          if (eventData.event && scrippsVideoPlayerEvents[eventData.event]) {
            scrippsVideoPlayerEvents[eventData.event](eventData);
          }
        } catch (err) {
          if (!(err instanceof SyntaxError)) {
            Sentry.captureException(err);
          }
        }
      });
    }

    initScrippsVideoPlayer();
    document.getElementById("browser-warnings")?.classList.add("hidden");
    document.getElementById("rewards-container")?.classList.remove("hidden");

    return () => {
      window.removeEventListener("message", () => {});
    };
  }, [adID, token]);

  return (
    <div className="App">
      <div id="browser-warnings">
        <noscript>Your browser does not support Javascript, or it is disabled. Please enable it to continue.</noscript>
        <div id="adblock-warning">It looks like you have an adblocker enabled. Please disable it to continue.</div>
      </div>
      <div id="rewards-container" className="rewards-container">
        <div className="billboard">
          <div id="scrippsvideoplayer" className="scrippsvideoplayer"></div>
          <img src={player} alt="Video Player" />
        </div>
      </div>
    </div>
  );
}

export default App;